import { render } from "./Pagination.vue?vue&type=template&id=d055b3a2"
import script from "./Pagination.ts?vue&type=script&lang=js&external"
export * from "./Pagination.ts?vue&type=script&lang=js&external"

import "./Pagination.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__